import React, { useState, useRef, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo-ti.png";
import { Link, useLocation } from "react-router-dom";
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";
import { BsTools, BsPaletteFill, BsSunFill, BsMoonStarsFill, BsStars, BsBuilding, BsMap, BsController } from "react-icons/bs";
import { useTheme, THEMES } from "../context/ThemeContext";
import { useLanguage, LANGUAGES } from "../context/LanguageContext";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const [showThemeDropdown, setShowThemeDropdown] = useState(false);
  const [showLangDropdown, setShowLangDropdown] = useState(false);
  const { theme, setTheme } = useTheme();
  const { language, setLanguage, t } = useLanguage();
  const location = useLocation();
  const path = location.pathname;
  const themeRef = useRef(null);
  const langRef = useRef(null);

  useEffect(() => {
    function scrollHandler() {
      if (window.scrollY >= 20) {
        updateNavbar(true);
      } else {
        updateNavbar(false);
      }
    }

    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (themeRef.current && !themeRef.current.contains(event.target)) {
        setShowThemeDropdown(false);
      }
      if (langRef.current && !langRef.current.contains(event.target)) {
        setShowLangDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const themeList = [
    { key: THEMES.CLAY, label: "Clay", icon: <BsPaletteFill style={{ color: "#a78bfa" }} /> },
    { key: THEMES.PURPLE, label: "Purple", icon: <BsStars style={{ color: "#c770f0" }} /> },
    { key: THEMES.DARK, label: "Dark", icon: <BsMoonStarsFill style={{ color: "#38bdf8" }} /> },
    { key: THEMES.LIGHT, label: "Light", icon: <BsSunFill style={{ color: "#f59e0b" }} /> },
  ];

  const currentThemeObj = themeList.find((t) => t.key === theme) || themeList[0];

  const FlagUS = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" width="22" height="14" style={{ borderRadius: "3px", display: "inline-block", verticalAlign: "middle" }}>
      <rect width="60" height="30" fill="#B22234"/>
      <rect y="2.31" width="60" height="2.31" fill="#fff"/>
      <rect y="6.92" width="60" height="2.31" fill="#fff"/>
      <rect y="11.54" width="60" height="2.31" fill="#fff"/>
      <rect y="16.15" width="60" height="2.31" fill="#fff"/>
      <rect y="20.77" width="60" height="2.31" fill="#fff"/>
      <rect y="25.38" width="60" height="2.31" fill="#fff"/>
      <rect width="24" height="16.15" fill="#3C3B6E"/>
    </svg>
  );

  const FlagVN = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 20" width="22" height="14" style={{ borderRadius: "3px", display: "inline-block", verticalAlign: "middle" }}>
      <rect width="30" height="20" fill="#DA251D"/>
      <polygon points="15,3.5 16.76,8.9 22.4,8.9 17.82,12.1 19.58,17.5 15,14.3 10.42,17.5 12.18,12.1 7.6,8.9 13.24,8.9" fill="#FFFF00"/>
    </svg>
  );

  const langList = [
    { key: LANGUAGES.EN, label: "EN", FlagIcon: FlagUS },
    { key: LANGUAGES.VI, label: "VI", FlagIcon: FlagVN },
  ];
  const currentLang = langList.find((l) => l.key === language) || langList[0];

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/"
                className={path === "/" ? "custom-nav-active" : ""}
                onClick={() => updateExpanded(false)}
              >
                <AiOutlineHome style={{ marginBottom: "2px" }} /> {t.nav.home}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/about"
                className={path === "/about" ? "custom-nav-active" : ""}
                onClick={() => updateExpanded(false)}
              >
                <AiOutlineUser style={{ marginBottom: "2px" }} /> {t.nav.about}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                as={Link}
                to="/project"
                className={path === "/project" ? "custom-nav-active" : ""}
                onClick={() => updateExpanded(false)}
              >
                <AiOutlineFundProjectionScreen
                  style={{ marginBottom: "2px" }}
                />{" "}
                {t.nav.projects}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="https://airi-tools.vercel.app/"
                target="_blank"
                rel="noreferrer"
                active={false}
                onClick={() => updateExpanded(false)}
              >
                <BsTools style={{ marginBottom: "2px" }} /> {t.nav.tool}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="https://tihub-office.vercel.app/"
                target="_blank"
                rel="noreferrer"
                active={false}
                onClick={() => updateExpanded(false)}
              >
                <BsBuilding style={{ marginBottom: "2px" }} /> {t.nav.office}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="https://ti-map.vercel.app/"
                target="_blank"
                rel="noreferrer"
                active={false}
                onClick={() => updateExpanded(false)}
              >
                <BsMap style={{ marginBottom: "2px" }} /> {t.nav.map}
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link
                href="https://ti-game.vercel.app/"
                target="_blank"
                rel="noreferrer"
                active={false}
                onClick={() => updateExpanded(false)}
              >
                <BsController style={{ marginBottom: "2px" }} /> {t.nav.game}
              </Nav.Link>
            </Nav.Item>

            {/* Language Switcher */}
            <Nav.Item style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}>
              <div className="theme-select-container" ref={langRef}>
                <button
                  className="theme-select-btn"
                  onClick={() => {
                    setShowLangDropdown(!showLangDropdown);
                    setShowThemeDropdown(false);
                  }}
                  title="Choose Language"
                >
                  <currentLang.FlagIcon />
                  <span style={{ marginLeft: "4px" }}>{currentLang.label}</span>
                </button>

                {showLangDropdown && (
                  <div className="theme-dropdown-menu">
                    {langList.map((item) => (
                      <button
                        key={item.key}
                        className={`theme-option-item ${language === item.key ? "active" : ""}`}
                        onClick={() => {
                          setLanguage(item.key);
                          setShowLangDropdown(false);
                          updateExpanded(false);
                        }}
                      >
                        <item.FlagIcon />
                        <span style={{ marginLeft: "4px" }}>{item.label}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </Nav.Item>

            {/* Theme Switcher */}
            <Nav.Item style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}>
              <div className="theme-select-container" ref={themeRef}>
                <button
                  className="theme-select-btn"
                  onClick={() => {
                    setShowThemeDropdown(!showThemeDropdown);
                    setShowLangDropdown(false);
                  }}
                  title="Choose Theme"
                >
                  {currentThemeObj.icon}
                  <span>{currentThemeObj.label}</span>
                </button>

                {showThemeDropdown && (
                  <div className="theme-dropdown-menu">
                    {themeList.map((item) => (
                      <button
                        key={item.key}
                        className={`theme-option-item ${theme === item.key ? "active" : ""}`}
                        onClick={() => {
                          setTheme(item.key);
                          setShowThemeDropdown(false);
                          updateExpanded(false);
                        }}
                      >
                        {item.icon}
                        <span>{item.label}</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
